import React from 'react';
import { matchRoutes, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useGetInvestmentFundQuery } from 'api/main';

import FundManagementTable from './FundManagementTable';
import FundAttributes from './fund-attributes/FundAttributes';
import PrivateFunds from './PrivateFunds';
import Tunnels from './Tunnels';
import VLManagement from './vl-management/VLManagement';
import { Loader } from 'components';

const routes = [
    {
        path: '/fund-management',
        children: [
            { path: ':fundId/vl-management' },
            { path: ':fundId/tunnels' },
            { path: ':fundId/reserved' },
            { path: ':fundId/attributes' },
            { path: ':fundId/*' },
        ],
    },
];

const FundManagement = () => {
    const { pathname } = useLocation();

    // use matchRoutes to extract fundId from the wildcard path
    const matches = matchRoutes(routes, pathname);
    const fundId = matches?.at(-1)?.params?.fundId;

    const { data: fund, isLoading } = useGetInvestmentFundQuery(fundId, { skip: !+fundId });

    return (
        <Routes>
            <Route path=":fundId/attributes" element={<FundAttributes />} />
            <Route path="create" element={<FundAttributes />} />
            <Route
                path=":fundId/reserved"
                element={
                    isLoading ? (
                        <Loader loading={isLoading} width="100%" />
                    ) : fund?.private ? (
                        <PrivateFunds fundName={fund?.name} />
                    ) : (
                        <Navigate replace to={'/fund-management'} />
                    )
                }
            />
            <Route
                path=":fundId/vl-management"
                element={
                    isLoading ? (
                        <Loader loading={isLoading} width="100%" />
                    ) : fund?.evergreen ? (
                        <VLManagement key={fund?.id} fund={fund} />
                    ) : (
                        <Navigate replace to={'/fund-management'} />
                    )
                }
            />
            <Route
                path=":fundId/tunnels"
                element={
                    isLoading ? (
                        <Loader loading={isLoading} width="100%" />
                    ) : (
                        <Tunnels fundName={fund?.name} />
                    )
                }
            />
            <Route index element={<FundManagementTable />} />
            <Route path="*" element={<Navigate to="/fund-management" replace />} />
        </Routes>
    );
};

export default FundManagement;
